import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
export function ProtectedRoute({
  children,
  requireOnboarded = true
}: {
  children: React.ReactNode;
  requireOnboarded?: boolean;
}) {
  const {
    isAuthenticated,
    isOnboarded
  } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-239" />;
  }
  if (requireOnboarded && !isOnboarded) {
    return <Navigate to="/onboarding/welcome" replace data-id="element-240" />;
  }
  if (!requireOnboarded && isOnboarded) {
    return <Navigate to="/app" replace data-id="element-241" />;
  }
  return <>{children}</>;
}